import { formatINR } from "@/lib/lamka";

export const RailHook = ({ price }) => (
  <div className="relative h-[46px] w-full flex justify-center" aria-hidden="true">
    <svg viewBox="0 0 24 46" className="h-[46px] w-6">
      <defs>
        <linearGradient id="rail-hook-metal" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F3F4F6" />
          <stop offset="1" stopColor="#6B7280" />
        </linearGradient>
      </defs>
      <path d="M12 16 a6.5 6.5 0 1 1 6.5 -6.5" fill="none" stroke="url(#rail-hook-metal)" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 16 V46" stroke="#C9CCD1" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
    <div className="absolute left-1/2 top-[20px] ml-[6px] origin-top-left -rotate-[10deg]">
      <span className="block h-[8px] w-px bg-[#C5A059]/70 ml-[3px]" />
      <span data-testid="thrift-hook-price-tag" className="block rounded-[3px] bg-[#F5F2EA] px-1.5 py-[2px] font-mono text-[9px] font-semibold text-[#0F0F0F] shadow-[0_2px_4px_rgba(0,0,0,0.4)] whitespace-nowrap">
        {formatINR(price)}
      </span>
    </div>
  </div>
);
